import {
  createApi,
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";

import { getAccessToken, getRefreshToken, setTokens } from "../hooks/token";

export type ErrorResponse = {
  code?: number;
  message?: string;
};

const cleanBaseQuery = fetchBaseQuery({
  baseUrl: "",
});

const baseQuery = fetchBaseQuery({
  baseUrl: "",
  prepareHeaders: (headers) => {
    const token = getAccessToken();

    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    const error = result.error.data as ErrorResponse;

    if (error.code === 40104) {
      result = await baseQuery(args, api, extraOptions);
    }

    // Retry with refresh
    if (error.code !== 40104) {
      const refreshResult: any = await cleanBaseQuery(
        {
          url: "/v1/auth/login-refresh",
          method: "POST",
          body: JSON.stringify({ token: getRefreshToken() }),
        },
        api,
        {
          ...extraOptions,
        }
      );
      if (refreshResult.data) {
        setTokens(refreshResult.data);
        result = await baseQuery(args, api, extraOptions);
      } else {
        // api.dispatch(loggedOut());
      }
    }
  }
  return result;
};

export const baseSplitApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});

export default baseSplitApi;
